var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_592_1",
    "data-name": "Component 592 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.834,
    height: 34.153,
    viewBox: "0 0 139.834 34.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 139.834,
    height: 34.153,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M64.815,26.217c-.023.159-.068.182-.2.182H55.554c-.159,0-.2-.068-.2-.182V11.63c0-.113.045-.182.182-.182h8.784c.137,0,.182.023.2.159l.251,2.116c.023.114-.023.205-.159.205H58.1v3.618h5.917c.113,0,.159.023.159.159v2.162c0,.113-.068.137-.159.137H58.1v3.913H65c.137,0,.182.069.159.182Z",
    transform: "translate(-8.928 -1.847)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M69.549,18.472c0-.774-.045-2-.091-2.457,0-.115.023-.16.159-.16h2.071c.159,0,.227.045.273.16a4.874,4.874,0,0,1,.159.864,5.02,5.02,0,0,1,3.3-1.251c1.707,0,3.8.865,3.8,4.506v6.736c0,.159-.069.2-.182.2H76.672a.181.181,0,0,1-.2-.2V20.383c0-1.5-.637-2.367-1.958-2.367a2.915,2.915,0,0,0-2.207.933v7.942a.167.167,0,0,1-.182.182H69.731c-.137,0-.182-.068-.182-.182Z",
    transform: "translate(-11.204 -2.521)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M85.446,13.929H80.827c-.114,0-.159-.069-.137-.183l.3-2.116c.023-.137.068-.182.2-.182H92.5c.137,0,.2.045.228.2l.2,2.071c.023.137-.046.205-.159.205h-4.6V26.195c0,.137-.068.2-.182.2H85.651c-.159.023-.2-.046-.2-.2Z",
    transform: "translate(-13.015 -1.847)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M97.754,15.854a.225.225,0,0,1,.25.182,5.127,5.127,0,0,1,.228,1.365,4.741,4.741,0,0,1,3.641-1.775c.137,0,.182.023.182.159V18.2c0,.114-.045.16-.2.16a4.419,4.419,0,0,0-3.481,1.206v7.328c0,.137-.069.182-.2.182H95.8c-.159,0-.205-.068-.205-.182V19.04c0-.979-.023-2.3-.113-3.05,0-.113.023-.136.137-.136Z",
    transform: "translate(-15.402 -2.521)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M114.975,24.614a20.043,20.043,0,0,0,.137,2.344c.023.114-.046.159-.182.159h-2.094c-.159,0-.2-.045-.227-.137a4.955,4.955,0,0,1-.159-.8,4.5,4.5,0,0,1-3.163,1.16c-2.162,0-3.824-1.16-3.824-4.346V16.057c0-.137.045-.159.182-.159h2.389c.137,0,.159.045.159.159V22.68c0,1.412.615,2.275,1.98,2.275a2.888,2.888,0,0,0,2.071-.819V16.057c0-.114.045-.159.182-.159h2.389c.137,0,.159.045.159.159Z",
    transform: "translate(-17.012 -2.565)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M124.162,17.833c-1.206,0-1.615.5-1.615.979,0,.5.341.841,1.8,1.411,2.594.956,3.481,1.98,3.481,3.6,0,2.14-1.684,3.482-4.483,3.482a7,7,0,0,1-3.209-.637c-.114-.069-.159-.114-.159-.25V24.251a.118.118,0,0,1,.182-.114,6.2,6.2,0,0,0,3.254.911c1.183,0,1.752-.41,1.752-1,0-.569-.432-.933-1.843-1.5-2.48-.91-3.367-1.935-3.367-3.573,0-1.73,1.411-3.346,4.255-3.346a7.022,7.022,0,0,1,2.868.455.276.276,0,0,1,.137.273v2c0,.114-.068.182-.2.137a6.479,6.479,0,0,0-2.845-.66",
    transform: "translate(-19.349 -2.521)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M137.368,26.113c0,.136-.023.227-.136.273a5.225,5.225,0,0,1-1.935.319c-1.866,0-2.981-.91-2.981-3.164V17.556h-1.434c-.114-.023-.159-.069-.159-.205V15.439c0-.137.045-.182.182-.182h1.434a23.944,23.944,0,0,1,.227-2.8c.023-.114.068-.183.182-.2l2.3-.319c.113-.023.158,0,.158.114-.068.751-.114,2.093-.114,3.208H137.3c.114,0,.16.045.16.159V17.4c0,.114-.046.16-.16.16h-2.23v5.393c0,1,.319,1.479,1.3,1.479a3.837,3.837,0,0,0,.866-.091c.067-.023.136,0,.136.137Z",
    transform: "translate(-21.087 -1.924)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M143.131,22.09c.069,1.593,1.115,2.867,3.436,2.867a7.172,7.172,0,0,0,2.822-.546c.068-.046.137-.023.137.091v1.889a.241.241,0,0,1-.137.25,7.561,7.561,0,0,1-3.413.66c-4.141,0-5.621-2.913-5.621-5.711,0-3.164,1.911-5.963,5.348-5.963a4.524,4.524,0,0,1,4.664,4.8,6.857,6.857,0,0,1-.091,1.411.2.2,0,0,1-.182.159,17.37,17.37,0,0,1-2.344.091Zm3.391-1.958a10.787,10.787,0,0,0,1.251-.023v-.181a2.1,2.1,0,0,0-2.184-2.117,2.487,2.487,0,0,0-2.458,2.321Z",
    transform: "translate(-22.64 -2.521)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M154.491,20.651c0-3.3,2.457-5.939,6.463-5.939a7.922,7.922,0,0,1,.979.068V10.115c0-.114.045-.159.136-.159h2.481c.113,0,.113.045.113.136V23.837c0,.455.046,1.047.091,1.457a.177.177,0,0,1-.136.2,10.788,10.788,0,0,1-4.3.887c-3.3,0-5.826-1.911-5.826-5.735m7.442-3.481a3.041,3.041,0,0,0-1.07-.159,3.331,3.331,0,0,0-3.549,3.5c0,2.481,1.479,3.5,3.3,3.5a4.209,4.209,0,0,0,1.32-.182Z",
    transform: "translate(-24.921 -1.606)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M21.268.527A17.073,17.073,0,1,0,33.627,21.268,17.072,17.072,0,0,0,21.268.527M16.439,8.644l5.483-.076a2.6,2.6,0,0,1,2.558,3.241l-12.263.169a4.417,4.417,0,0,1,4.222-3.334M6.461,16.362a1.636,1.636,0,0,1,1.564-1.235L16.9,15a1.637,1.637,0,0,1,.046,3.274L8.072,18.4a1.638,1.638,0,0,1-1.61-2.04m11.393,8.271-5.482.075a2.6,2.6,0,0,1-2.559-3.24L22.077,21.3a4.417,4.417,0,0,1-4.223,3.334M25,16.532A2.377,2.377,0,0,1,22.823,18.2a1.259,1.259,0,0,1-1.34-1.622,2.374,2.374,0,0,1,2.173-1.671A1.26,1.26,0,0,1,25,16.532",
    transform: "translate(0 0)",
    fill: "#0f58e5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntLogo);
export default __webpack_public_path__ + "static/media/ent-logo.5cc9a262967956dcd2edb1bde1fe7658.svg";
export { ForwardRef as ReactComponent };